import { render } from "./ContactPage.vue?vue&type=template&id=fa126884&lang=pug"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=fa126884&lang=scss"
script.render = render

export default script